import parsePhoneNumber, {
    CountryCode,
    isSupportedCountry,
    validatePhoneNumberLength,
} from 'libphonenumber-js';
import { FormValidationRule } from './types';

export const validationPhoneNumber = (data: string, countryCode: CountryCode): boolean => {
    if (data) {
        const phoneNumber = parsePhoneNumber(data, countryCode);

        if (!phoneNumber || !phoneNumber.isPossible() || !phoneNumber.isValid()) {
            return false;
        }
    }

    return true;
};

export const getValidationPhoneNumberError = (
    data: string,
    countryCode: CountryCode,
): string | true => {
    if (!data || data === '+' || !isSupportedCountry(countryCode)) {
        return true;
    }

    const phoneNumber = parsePhoneNumber(data, countryCode);

    if (phoneNumber && phoneNumber.isPossible() && phoneNumber.isValid()) {
        return true;
    }

    if (validatePhoneNumberLength(data, countryCode) === 'TOO_SHORT') {
        return 'Le numéro de téléphone est trop court';
    }

    if (countryCode !== 'FR') {
        return 'Le numéro international doit commencer par +, suivi de l’indicatif du pays et du numéro sans espaces';
    }

    return `Ce numéro de téléphone n'est pas valide`;
};

export function validationPhoneNumberRule(countryCode: CountryCode): FormValidationRule {
    const validationRule = (value: string) =>
        validationPhoneNumber(value, countryCode) ||
        getValidationPhoneNumberError(value, countryCode);

    return { phoneNumber: validationRule };
}
